// tslint:disable:no-object-literal-type-assertion
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import AnalyticsService from '../../../services/AnalyticsService';
import { IInvoicesStore } from '../../../stores/InvoicesStore';
import { ITranslateStore } from '../../../stores/TranslateStore';

import MasterRefNumberPaymentModal from './MasterRefNumberPaymentModal';

interface IPrepaymentModalProps {
  invoicesStore?: IInvoicesStore;
  translateStore?: ITranslateStore;
  analyticsService?: AnalyticsService;
}

@inject('invoicesStore', 'translateStore', 'analyticsService')
@observer
export default class PrepaymentModal extends React.Component<IPrepaymentModalProps> {
  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;
    const analyticsService = this.props.analyticsService;

    return (
      <MasterRefNumberPaymentModal
        amount={this.props.invoicesStore.defaultPrepaymentAmount}
        headingLabel={translate('shared.payment-modal.make-prepayment')}
        amountFieldLabel={translate('shared.payment-modal.prepayment-sum')}
        onRedirectToBank={(banklinkName) => analyticsService.paymentModalMakePrepayment(banklinkName)}
      />
    );
  }
}
